// Import our custom CSS
import '../scss/theme.scss'

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

function navbarBehaviour() {

    var navbar = document.querySelector("header .navbar.js--hideScroll");
    // Trovo l'altezza della navbar

    if (navbar) {
        var navbarHeight = navbar.offsetHeight;

        // Aggiungo l'altezza della navbar come padding all'elemento main
        var mainContent = document.querySelector('main.main-content');
        mainContent.style.paddingTop = navbarHeight + 'px';

        // Salvo la posizione dello scroll verticale
        var prevScrollpos = window.pageYOffset;
        var scrolledDown = false;

        // Evento scroll sull'oggetto window
        window.onscroll = function () {
            var currentScrollPos = window.pageYOffset;

            // Se l'user scrolla +200px si attiva l'effetto
            if (currentScrollPos > 200) {
                scrolledDown = true;
            } else {
                scrolledDown = false;
            }

            if (scrolledDown) {
                if (prevScrollpos > currentScrollPos) {
                    navbar.style.top = '0';
                } else {
                    navbar.style.top = '-' + navbarHeight + 'px';
                }
            }

            prevScrollpos = currentScrollPos;
        };
    }

}

navbarBehaviour();


jQuery(function ($) {

    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        //>=, not <=
        if (scroll >= 150) {
            //clearHeader, not clearheader - caps H
            $("body").addClass("is-scrolled");
        } else {
            $("body").removeClass("is-scrolled");
        }
    }); //missing );

}); // jQuery End


document.addEventListener("DOMContentLoaded", function () {

    // Gsap
    let tl = gsap.timeline();

    tl.to(".splash-screen", {
        duration: 1,
        opacity: 0,
        onComplete: function () {
            // Una volta che l'animazione è completata, nasconde la splash screen e mostra il contenuto principale
            document.querySelector(".splash-screen").style.display = "none";
        }
    });

    if (window.innerWidth > 992) {
        tl.from("header .menu-item", {opacity: 0, y: -50, stagger: 0.1, duration: 0.6, ease: "power2.out"});
    }

    if (document.querySelectorAll('.hero_three_columns').length > 0) {
        // tl.from(".hero_three_columns .column-image", {
        //     opacity: 0,
        //     duration: 0.3,
        //     ease: "power2.out"
        // });

        tl.to(".hero_three_columns .column-text", {
            opacity: 1,
            y: 0,
            duration: 1,
            // stagger: 0.3,
            ease: "power2.out"
        });
    }

    // Mobile menu
    let myOffcanvas = document.getElementById('navbarOffcanvas')
    myOffcanvas.addEventListener('show.bs.offcanvas', function () {
        gsap.from("#navbarOffcanvas .menu-item", {opacity: 0, y: -50, stagger: 0.3, duration: 0.6, ease: "power2.out"});
    });


    // Elementi che si animano all'ingresso nel viewport
    ScrollTrigger.batch(".fade-up", {
        start: "top 80%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {opacity: 1, stagger: 0.3, y: 0, duration: 1.5});
        }

    });

    ScrollTrigger.batch(".fade-down", {
        start: "top 80%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {opacity: 1, stagger: 0.3, y: 0, duration: 1.5});
        }

    });

    ScrollTrigger.batch(".reveal", {
        start: "top 80%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {
                clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                y: 0,
                duration: 1,
                stagger: 0.3,
                ease: "power3.out"
            });
        }
    });

    if (document.querySelectorAll('.hm-block-hero-2').length > 0 && document.querySelectorAll('.image-scale-gsap').length > 0) {

        gsap.to(".image-scale-gsap", {
            scale: 1.1,
            ease: "power3.out",
            scrollTrigger: {
                trigger: ".hm-block-hero-2",
                start: "80% 80%",
                end: "bottom top",
                // markers: true,
                scrub: true,
            }
        });

    }


    new Swiper(".hm-image-carousel", {
        slidesPerView: 1.2,
        spaceBetween: 50,
        slidesToScroll: 1,
        loop: false,
        autoplay: {
            delay: 3000, // Tempo di visualizzazione di ogni slide in millisecondi
            disableOnInteraction: false, // Non interrompere autoplay quando l'utente interagisce con la slide
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
        },
        breakpoints: {
            600: {
                slidesPerView: 2.5,
                slidesToScroll: 1,
            }
        },
    });

    new Swiper(".swiper-room", {
        slidesPerView: 1,
        spaceBetween: 50,
        slidesToScroll: 1,
        loop: false,
        autoplay: {
            delay: 3000, // Tempo di visualizzazione di ogni slide in millisecondi
            disableOnInteraction: false, // Non interrompere autoplay quando l'utente interagisce con la slide
        },
        pagination: {
            el: ".swiper-pagination",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

});